<app-navsec></app-navsec>
<div class="container">
    <div class="col-lg-12 d-none d-lg-block d-xl-block">
        <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
            <div class="registro">
                <div class="regForm">
                    <h4>Registro de usuario Torreón Market</h4>
                    <hr>
                    <div class="form-group">
                        <label for="email">E-mail:</label>
                        <input type="email" class="form-control" placeholder="Ingrese su email" formControlName="email" [class.is-invalid]="emailNoValido">
                        <small class="eml" *ngIf="emailNoValido">Ingrese un email válido</small>
                    </div>
                    <div class="form-group">
                        <label for="email">Contraseña:</label>
                        <div class="row" *ngIf="passwordView == false">
                            <input type="password" class="form-control pass" formControlName="password" [class.is-invalid]="passwordNoValido">
                            <button class="btn btn-light viewPass" (click)="viewPassActive()"><i class="fa fa-eye-slash fa-lg"></i></button>
                            <small class="spn" *ngIf="passwordNoValido">La contraseña debe ser de 8 caracteres mínimo.</small>
                        </div>
                        <div class="row" *ngIf="passwordView == true">
                            <input type="text" class="form-control pass" formControlName="password" [class.is-invalid]="passwordNoValido">
                            <button class="btn btn-light viewPass" (click)="viewPassInActive()"><i class="fa fa-eye fa-lg"></i></button>
                            <small class="spn" *ngIf="passwordNoValido">La contraseña debe ser de 8 caracteres mínimo.</small>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-outline-dark btnIngreso"><i class="fa fa-user-circle" aria-hidden="true"></i> CREAR CUENTA</button>
                    <br><br>
                    <h5>Regístrate con tu cuenta de:</h5>
                    <hr>
                    <div class="col-12">
                        <div class="row">
                            <div class="col-6">
                                <button class="btn btn-danger btn-block" (click)="onLoginGoogle()">
                                <i class="fa fa-google fa-lg" aria-hidden="true"></i>
                            </button>
                            </div>
                            <div class="col-6">
                                <button class="btn btn-primary btn-block" (click)="onLoginFacebook()">
                                <i class="fa fa-facebook fa-lg" aria-hidden="true"></i>
                            </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="col-lg-12 d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
        <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
            <div class="regMovil">
                <div class="regForm">
                    <h4>Registro de usuario Torreón Market</h4>
                    <hr>
                    <div class="form-group">
                        <label for="email">E-mail:</label>
                        <input type="email" class="form-control" placeholder="Ingrese su email" formControlName="email" [class.is-invalid]="emailNoValido">
                        <small class="eml" *ngIf="emailNoValido">Ingrese un email válido</small>
                    </div>
                    <div class="form-group">
                        <label for="email">Contraseña:</label>
                        <div class="row" *ngIf="passwordView == false">
                            <input type="password" class="form-control pass" formControlName="password" [class.is-invalid]="passwordNoValido">
                            <button class="btn btn-light viewPass" (click)="viewPassActive()"><i class="fa fa-eye-slash fa-lg"></i></button>
                            <small class="spn" *ngIf="passwordNoValido">La contraseña debe ser de 8 caracteres mínimo.</small>
                        </div>
                        <div class="row" *ngIf="passwordView == true">
                            <input type="text" class="form-control pass" formControlName="password" [class.is-invalid]="passwordNoValido">
                            <button class="btn btn-light viewPass" (click)="viewPassInActive()"><i class="fa fa-eye fa-lg"></i></button>
                            <small class="spn" *ngIf="passwordNoValido">La contraseña debe ser de 8 caracteres mínimo.</small>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-outline-dark btnIngreso"><i class="fa fa-user-circle" aria-hidden="true"></i> CREAR CUENTA</button>
                    <br><br>
                    <h5>Regístrate con tu cuenta de:</h5>
                    <hr>
                    <div class="col-12">
                        <div class="row">
                            <div class="col-6">
                                <button class="btn btn-danger btn-block" (click)="onLoginGoogle()">
                                <i class="fa fa-google fa-lg" aria-hidden="true"></i>
                            </button>
                            </div>
                            <div class="col-6">
                                <button class="btn btn-primary btn-block" (click)="onLoginFacebook()">
                                <i class="fa fa-facebook fa-lg" aria-hidden="true"></i>
                            </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<app-footer></app-footer>